import { render, staticRenderFns } from "./VendorField.vue?vue&type=template&id=80f7d092&scoped=true&"
import script from "./VendorField.vue?vue&type=script&lang=js&"
export * from "./VendorField.vue?vue&type=script&lang=js&"
import style0 from "./VendorField.vue?vue&type=style&index=0&id=80f7d092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f7d092",
  null
  
)

export default component.exports